

















import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import VideoPublication from '@/models/videoPublication';

export enum VideoCardSize {
  Default = 'default',
  Big = 'big'
}

export default Vue.extend({
  name: 'VideoCard',
  props: {
    video: {
      type: Object as PropType<VideoPublication>,
      required: true,
    },
    size: {
      type: String as PropType<VideoCardSize>,
      default: () => VideoCardSize.Default.toString(),
      validator: (value: string) => [
        VideoCardSize.Default.toString(),
        VideoCardSize.Big.toString(),
      ].indexOf(value) !== -1,
    },
  },
  methods: {
    urlFor,
    onVideoClick(videoPublicationSlug: string) {
      this.$router.push(`/media/${videoPublicationSlug}`);
    },
  },
  computed: {
    imageWidth() {
      return this.size === VideoCardSize.Big.toString() ? 960 : 470;
    },
  },
});
